import styled from "styled-components";

export const IconContainerStyled = styled.div`
  width: 100%;
  position: relative;
`;
